
const defaultState = {
  id: -1,
  before: '',
  after: '',
  content: '',
  contentFuture: '',
  documentIndex: [],
  loading: true
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SBA_FETCH_BEGIN':
      return { ...state, loading: true }
    case 'SBA_FETCH_SUCCESS':
      return { ...state, ...action.payload, before: action.payload.after, loading: false }
    case 'SBA_EDIT':
      return { ...state, ...action.payload }
    case 'SBA_SAVE_BEGIN':
      return { ...state, loading: true }
    case 'SBA_SAVE_SUCCESS':
      return { ...state, loading: false }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/sba/sbaReducers.js